import axios from "axios";

import { clearBrowserStorage } from "../utils/localStorage";

const initialState = {
	email: "",
	merchantCode: "",
	merchantCodeList: [], // user merchants
	merchantRequests: [], // user merchant requests
	name: "",
	verified: true, // if user verified email or not
	merchantName: null,
	merchantLogo: null,
	meta: [],
	autoFill: null,
	isB2B: false,
	serviceType: [],
	isAutoStockLowProcurement: false
};

const createUserSlice = (set, get) => ({
	user: initialState,
	menu: [],
	menuItems: [],
	token: null,
	permission: [],
	setUser: data => {
		set(prev => {
			const {
				permission = prev.permission,
				token = prev.token,
				email = prev.user.email,
				isB2B = prev.user.isB2B,
				serviceType = prev.user.serviceType,
				merchantCode = prev.user.merchantCode,
				merchantCodeList = prev.user.merchantCodeList,
				name = prev.user.name,
				menu = prev.user.menu,
				contractType = prev.user.contractType,
				codeVerified = prev.user.codeVerified,
				menuItems = prev.user.menuItems,
				verified = prev.user.verified,
				merchantRequests = prev.user.merchantRequests,
				merchantName = prev.user.merchantName,
				merchantLogo = prev.user.merchantLogo,
				meta = prev.user.meta,
				autoFill = prev.user.autoFill,
				isAutoStockLowProcurement= prev.user.isAutoStockLowProcurement
			} = data;
			return {
				token,
				menu,
				menuItems,
				permission,
				user: {
					...prev.user,
					email,
					merchantCode,
					isB2B,
					serviceType,
					merchantCodeList,
					name,
					verified,
					merchantRequests,
					merchantName,
					merchantLogo,
					meta,
					contractType,
					autoFill,
					codeVerified,
					isAutoStockLowProcurement
				}
			};
		});
	},
	changeMerchant: async merchantCode => {
		const { data } = await axios.post(`/api/v1.0/merchant/refresh`, {
			code: merchantCode
		});

		if (data.statusCode === 200) {
			const {
				token,
				menu,
				menuItems,
				merchantName,
				merchantLogo,
				meta,
				contractType,
				permission,
				isB2B,
				serviceType,
				email,
				isAutoStockLowProcurement
			} = data?.result ?? {};

			// Хуучин merchant-ийн бүх локал үлдэгдлийг устгана. Доорх `set` нь
			// persist-ээр дамжуулан шинэ merchant-ийн store-ыг шууд буцаан бичнэ.
			clearBrowserStorage();

			set(prev => {
				return {
					user: {
						...prev.user,
						token,
						merchantCode,
						contractType,
						merchantName,
						merchantLogo,
						meta,
						isB2B,
						serviceType,
						email,
						isAutoStockLowProcurement
					},
					permission,
					menu,
					menuItems,
					token
				};
			});

			window.location.href = "/merchant/order/delivery";
		}
	},
	setToken: (token, verified = true) => {
		set(prev => {
			return {
				token,
				user: {
					...prev.user,
					verified
				}
			};
		});
	}
});

export default createUserSlice;
